import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
interface FieldShellProps {
  id: string;
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  className?: string;
  children: React.ReactNode;
}
export function describedBy(id: string, hint?: string, error?: string): string | undefined {
  const ids = [hint ? `${id}-hint` : '', error ? `${id}-error` : ''].filter(Boolean);
  return ids.length ? ids.join(' ') : undefined;
}
export function FieldShell({
  id,
  label,
  required,
  hint,
  error,
  className,
  children
}: FieldShellProps) {
  return <div className={`min-w-0 ${className ?? ''}`} data-id="element-122" data-mp="3e4arex7kriat">
      <label htmlFor={id} className="flex items-baseline justify-between gap-3 text-[15px] font-semibold text-ink" data-id="element-123" data-mp="3087au6pmj8gt">
        <span data-id="element-124" data-mp="356ihk8kmh2ut">
          {label}
          {required && <span aria-hidden="true" className="ml-0.5 text-brand-deep" data-id="element-125" data-mp="yf9cjvd2vnoh">
              *
            </span>}
        </span>
        {!required && <span className="text-[13px] font-normal text-steel" data-id="element-126" data-mp="13duatp8rrxaa">Optional</span>}
      </label>
      {hint && <p id={`${id}-hint`} className="mt-1 text-sm text-steel" data-id="element-127" data-mp="3cjx93amsvedj">
          {hint}
        </p>}
      <div className="mt-2" data-id="element-128" data-mp="38iloxkmp3lcq">{children}</div>
      {error && <p id={`${id}-error`} className="mt-2 flex items-start gap-1.5 text-sm font-medium text-brand-deep" data-id="element-129" data-mp="3mai3smzcryr6">
          <AlertCircleIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" data-id="element-130" data-mp="3hd9tf8kg4z0h" />
          {error}
        </p>}
    </div>;
}